define(function (require) {

    var ViewController = require('web-agent-framework/ViewController');
    var lpUtils = require('utils/lpUtils');

    var BotEscalationBubbleViewController = ViewController.extend({
        ControllerName: "BotEscalationBubbleViewController",
        applicationType: 'BotEscalationBubbleViewController',
        templateFile: 'LP_bot_escalation_chat_bubble.html',


        LPViewMap: {
            topicsPlaceholder: '.bot_escalation_chat_bubble_row_topics'
        },

        initialize: function (constructorData) {
            this.data = constructorData;
            this._initializeView();
        }
    });

    BotEscalationBubbleViewController.prototype._initializeView = function () {
        var topicsPlaceholder = this.getFirstElement(this.LPViewMap.topicsPlaceholder);
        var botTopicsTemplate = require('web-agent-templates/LP_bot_escalation_chat_bubble_topic.tmpl.html');
        topicsPlaceholder.innerHTML = _.template(botTopicsTemplate ,{topics : this.data.textInjection.topics || [], title: this.translate('bot_escalation_chat_bubble_topics')});
    };

    return BotEscalationBubbleViewController;
});
